import * as yup from "yup";

export const ScholarshipTypeformValidation = yup.object().shape({
    description: yup.string().required("O nome é obrigatório"),
    status: yup.boolean().default(true)
});
